import { h, Component } from "preact";

import style from "./style.css";
import SwitchList from "./list-switch";

import Alphabet from "../alphabet";
import ListFilter from "../list-filter";

class TitleList extends Component {
  state = {
    filterByLetter: false,
    filterByPhrase: false,
    alphabet: [],
    listLoaded: false,
    shouldResetAlphabet: false,
    shouldResetFilter: false,
    shouldResetAll: false,
  };

  setFilterByLetter = (letter) => {
    this.setState((previousState) => ({
      ...previousState,
      filterByLetter: letter,
      shouldResetAlphabet: false,
      shouldResetFilter: false,
    }));
  };

  onListLoaded = (firstCharacterArray) => {
    // This gets called when a new search type is selected, so the alphabet and filter should reset
    this.setState((previousState) => ({
      ...previousState,
      alphabet: firstCharacterArray,
      listLoaded: true,
      shouldResetAlphabet: true,
      shouldResetFilter: true,
      shouldResetAll: true,
    }));
  };

  handleFilter = (phrase) => {
    this.setState((previousState) => ({
      ...previousState,
      filterByPhrase: phrase,
      shouldResetAlphabet: false,
      shouldResetFilter: false,
    }));
  };

  render({
    pageTitle = "Resultaat",
    subTitle = "",
    displayList,
    displayType,
    database,
    locale,
  }) {
    return (
      <div class={style["title-list"]}>
        <header class={style["title-list__header"]}>
          <h2 class={style["title-list__title"]}>
            {pageTitle}
            {subTitle ? <span> - {subTitle}</span> : ""}
          </h2>
          {this.state.listLoaded && (
            <ListFilter
              handleFilterChange={this.handleFilter}
              shouldResetFilter={this.state.shouldResetFilter}
            />
          )}
        </header>
        {this.state.listLoaded && (
          <Alphabet
            setFilterByLetter={this.setFilterByLetter}
            alphabet={this.state.alphabet}
            setPhrase={this.state.filterByPhrase}
            resetAlphabet={this.state.shouldResetAlphabet}
          />
        )}
        <SwitchList
          displayList={displayList}
          displayType={displayType}
          database={database}
          filterByLetter={this.state.filterByLetter}
          filterByPhrase={this.state.filterByPhrase}
          resetAll={this.state.shouldResetAll}
          onListLoaded={this.onListLoaded}
          locale={locale}
        />
      </div>
    );
  }
}

export default TitleList;
